<template>
  <div class="home">
    <div class="topInfo">
      <Setting></Setting>
      <Notice class="m-x-20"></Notice>
      <User></User>
    </div>
    <div class="content">
      <el-tabs v-model="activeName" @tab-click="handleTabClick">
        <el-tab-pane v-for="item in tagList" :key="item.name" :label="item.label" :name="item.name"></el-tab-pane>
      </el-tabs>
      <Search ref="search" :searchConfig="searchConfig" @doSearch="doSearch" />
      <Table ref="table" class="table" :tableConfig="tableConfig">
        <!-- 人员信息 -->
        <template :slot="'userAbilityList'" slot-scope="scope">
          {{ (scope.row.userAbilityList || []).join("/") }}
        </template>
        <template :slot="'onOrOffStr'" slot-scope="scope">
          <div>
            <span>{{ scope.row.onOrOffStr }}</span>
            <el-link type="primary" class="ml-8" @click="onChangeUserType(scope.row)">{{
              scope.row.onOrOff ? '禁用' : '启用'
            }}</el-link>
          </div>

        </template>
        <!-- 申请属性 -->
        <template :slot="'supplierAbilityApplyNo'" slot-scope="scope">
          <el-link @click="toAttrApplyDetail(scope.row)">{{
            scope.row.supplierAbilityApplyNo
          }}</el-link>
        </template>
        <template :slot="'industryFiles'" slot-scope="scope">
          <el-link class="ellipsis_fileList" type="primary" @click="onShowFiles(scope.row.industryFiles)">{{
            (scope.row.industryFiles || []).map((i) => i.fileName).join(",")
            }}</el-link>
        </template>
        <template :slot="'abilityList'" slot-scope="scope">
          {{ (scope.row.abilityList || []).join("/") }}
        </template>
        <template :slot="'proofFiles'" slot-scope="scope">
          <el-link class="ellipsis_fileList" type="primary" @click="onShowFiles(scope.row.proofFiles)">{{
            (scope.row.proofFiles || []).map((i) => i.fileName).join(",") }}</el-link>
        </template>

        <!-- 个人申请单号 -->
        <template :slot="'supplierUserAbilityApplyNo'" slot-scope="scope">
          <el-link @click="toUserApplyDetail(scope.row)">{{
            scope.row.supplierUserAbilityApplyNo
          }}</el-link>
        </template>
        <!-- 子账号 -->
        <template :slot="'supplierUserApplyNo'" slot-scope="scope">
          <el-link @click="toAccountApplyDetail(scope.row)">{{
            scope.row.supplierUserApplyNo
          }}</el-link>
        </template>
        <!-- 个人申请 -->
        <template :slot="'ability3'" slot-scope="scope">
          {{ scope.row.ability1Name }}/{{ scope.row.ability2Name }}/{{
            scope.row.ability3Name
          }}
        </template>
        <template :slot="'supplierUserApplyFiles'" slot-scope="scope">
          <el-link class="ellipsis_fileList" type="primary" @click="onShowFiles(scope.row.supplierUserApplyFiles)">{{
            (scope.row.supplierUserApplyFiles || []).map((i) => i.fileName).join(",")
            }}</el-link>
        </template>
      </Table>
    </div>
    <FilesDialog ref="filesDialog" />
  </div>
</template>
<script>
import Setting from "./component/setting.vue";
import Notice from "./component/notice.vue";
import User from "./component/user.vue";
import Table from "../component/table.vue";
import Search from "../component/search.vue";
import FilesDialog from "../component/filesDialog.vue";

import {
  userInfoTableConfig,
  attrTableConfig,
  accountTableConfig,
  userTagTableConfig,
  userInfoSearchConfig,
  attrSearchConfig,
  baseSearchConfig,
} from "./help";

export default {
  components: {
    Setting,
    Notice,
    User,
    Table,
    Search,
    FilesDialog,
  },
  data() {
    return {
      activeName: "1",
    };
  },
  mounted() {
    // 工程师只显示 人员标签申请
    if (this.$store.state.ecology.userInfo.userType == 1) {
      this.activeName = "1";
    } else if (this.$store.state.ecology.userInfo.userType == 2) {
      this.activeName = "4";
    } else {
      this.activeName = "";
    }
    console.log("home mounted");

    this.$nextTick(() => {
      this.$refs.search && this.$refs.search.doSearch();
    });
  },
  computed: {
    tagList() {
      const list = [
        {
          label: "人员信息",
          name: "1",
        },
        {
          label: "属性标签申请",
          name: "2",
        },
        {
          label: "子账号激活申请",
          name: "3",
        },
        {
          label: "人员标签申请",
          name: "4",
        },
      ];
      if (this.$store.state.ecology.userInfo.userType == 1) {
        return list;
      } else if (this.$store.state.ecology.userInfo.userType == 1) {
        return [
          {
            label: "人员标签申请",
            name: "4",
          },
        ];
      } else {
        return [];
      }
    },
    tableConfig() {
      let config = {};
      switch (this.activeName) {
        case "1":
          config = userInfoTableConfig;
          break;
        case "2":
          config = attrTableConfig;
          break;
        case "3":
          config = accountTableConfig;
          break;
        case "4":
          config = userTagTableConfig;
          break;
      }
      return config;
    },
    searchConfig() {
      switch (this.activeName) {
        case "1":
          return userInfoSearchConfig;
        case "2":
          return attrSearchConfig;
        default:
          return baseSearchConfig;
      }
    },
  },
  methods: {
    onShowFiles(list) {
      this.$refs.filesDialog.onShow(list);
    },
    doSearch(input) {
      this.tableConfig.extra = {
        companyId: this.$store.state.user.defaultCompanyId,
        ...input,
      };
      this.$refs.table.getList();
    },
    handleTabClick() {
      this.$nextTick(() => {
        this.$refs.search.doSearch();
      });
    },
    toUserApplyDetail(row) {
      this.$router.push({
        path: "/ecologicalServices/person-detail",
        query: {
          id: row.id,
        },
      });
    },
    toAttrApplyDetail(row) {
      this.$router.push({
        path: "/ecologicalServices/company-detail",
        query: {
          id: row.id,
        },
      });
    },
    toAccountApplyDetail(row) {
      this.$router.push({
        path: "/ecologicalServices/account-detail",
        query: {
          id: row.id,
        },
      });
    },
    onChangeUserType(res) {
      this.$http.post(`/front/oms/supplier/User/enableUser`, {
        id: res.id,
        enable: !res.onOrOff
      }).then(({ data: res }) => {
        if (res.code === 0) {
          this.$message.success('操作成功');
          this.$refs.search.doSearch();
        }
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.home {
  padding: 20px 0;

  ::v-deep .el-tabs__item.is-active {
    color: #2a54d1;
  }

  ::v-deep .el-tabs__item {
    font-family: Alibaba PuHuiTi;
    font-size: 16px;
    font-weight: bold;
    color: #666;
  }

  ::v-deep .el-tabs__active-bar {
    background-color: #2a54d1;
  }
}

.topInfo {
  width: 1200px;
  display: flex;
}

.content {
  height: 780px;
  margin-top: 20px;
  background: #fff;
  padding: 10px 20px;
  width: 1200px;
}

.m-x-20 {
  margin-right: 20px;
  margin-left: 20px;
}

.mt-16 {
  margin-top: 16px;
}

.ml-8 {
  margin-left: 8px;
}

.table {
  margin-top: 16px;
  height: 600px;
}

.ellipsis_fileList {
  width: 100%;

  ::v-deep .el-link--inner {
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
    overflow: hidden;
  }
}
</style>
